import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const examManageJnrd = {
    examSetting: {
        list: config => createAPI('/examSettingJnrd/list', 'post', config),
        initOption: config => createAPI('/examSettingJnrd/initOption', 'post', config),
        initExamInfo: config => createAPI('/examSettingJnrd/initExamInfo', 'post', config),
        saveRec: config => createAPI('/examSettingJnrd/saveRec', 'post', config),
        delRec: config => createAPI('/examSettingJnrd/delRec', 'post', config),
        queryClassTree: config => createAPI('/examSettingJnrd/queryClassTree', 'post', config),

        queryExamTimeList: config => createAPI('/examSettingJnrd/queryExamTimeList', 'post', config),
        saveExamTime: config => createAPI('/examSettingJnrd/saveExamTime', 'post', config),
        delExamTime: config => createAPI('/examSettingJnrd/delExamTime', 'post', config),

        queryInvigilator: config => createAPI('/examSettingJnrd/queryInvigilator', 'post', config),
        saveMaxInvigilator: config => createAPI('/examSettingJnrd/saveMaxInvigilator', 'post', config),
        delTeacher: config => createAPI('/examSettingJnrd/delTeacher', 'post', config),
        queryInvigilatorTree: config => createAPI('/examSettingJnrd/queryInvigilatorTree', 'post', config),
        saveAddTeacher: config => createAPI('/examSettingJnrd/saveAddTeacher', 'post', config),

        queryExamSite: config => createAPI('/examSettingJnrd/queryExamSite', 'post', config),
        delExamSite: config => createAPI('/examSettingJnrd/delExamSite', 'post', config),
        querySiteTree: config => createAPI('/examSettingJnrd/querySiteTree', 'post', config),
        saveAddSite: config => createAPI('/examSettingJnrd/saveAddSite', 'post', config),

        queryExamCourseSet: config => createAPI('/examSettingJnrd/queryExamCourseSet', 'post', config),
        examCourseSetOption: config => createAPI('/examSettingJnrd/examCourseSetOption', 'post', config),
        saveCourseSet: config => createAPI('/examSettingJnrd/saveCourseSet', 'post', config),

        queryClassExamInfo: config => createAPI('/examSettingJnrd/queryClassExamInfo', 'post', config),
        classCourseOption: config => createAPI('/examSettingJnrd/classCourseOption', 'post', config),
        queryTeacher: config => createAPI('/examSettingJnrd/queryTeacher', 'post', config),
        querySite: config => createAPI('/examSettingJnrd/querySite', 'post', config),
        saveKCAP: config => createAPI('/examSettingJnrd/saveKCAP', 'post', config),

        resitList: config => createAPI('/examSettingJnrd/resitList', 'post', config),
        saveResitInfo: config => createAPI('/examSettingJnrd/saveResitInfo', 'post', config),
        queryResitSetInfo: config => createAPI('/examSettingJnrd/queryResitSetInfo', 'post', config),
        delResit: config => createAPI('/examSettingJnrd/delResit', 'post', config),
    },
    examSchedule: {
        list: config => createAPI('/examScheduleJnrd/list', 'post', config),
        save: config => createAPI('/examScheduleJnrd/save', 'post', config),
        pkRec: config => createAPI('/examScheduleJnrd/pkRec', 'post', config),
        initCombo: config => createAPI('/examScheduleJnrd/initCombo', 'post', config),
        initComboKSCD: config => createAPI('/examScheduleJnrd/initComboKSCD', 'post', config),
        initOption: config => createAPI('/examScheduleJnrd/initOption', 'post', config),
        examOption: config => createAPI('/examScheduleJnrd/examOption', 'post', config),
        baseParam: config => createAPI('/examScheduleJnrd/baseParam', 'post', config),
        queryExamInfo: config => createAPI('/examScheduleJnrd/queryExamInfo', 'post', config),
        autoArrangeExam: config => createAPI('/examScheduleJnrd/autoArrangeExam', 'post', config),
        resitArrangeList: config => createAPI('/examScheduleJnrd/resitArrangeList', 'post', config),
        resitStuInfo: config => createAPI('/examScheduleJnrd/resitStuInfo', 'post', config),
        saveResitInfo: config => createAPI('/examScheduleJnrd/saveResitInfo', 'post', config),
        saveExamArrange: config => createAPI('/examScheduleJnrd/saveExamArrange', 'post', config),
        queryStuSiteList: config => createAPI('/examScheduleJnrd/queryStuSiteList', 'post', config),
        saveExamSiteChange: config => createAPI('/examScheduleJnrd/saveExamSiteChange', 'post', config),
        saveRsyq: config => createAPI('/examScheduleJnrd/saveRsyq', 'post', config),
        queryTeaList: config => createAPI('/examScheduleJnrd/queryTeaList', 'post', config),
        addHxjs: config => createAPI('/examScheduleJnrd/addHxjs', 'post', config),
        queryHxlb: config => createAPI('/examScheduleJnrd/queryHxlb', 'post', config),
        removeHxjs: config => createAPI('/examScheduleJnrd/removeHxjs', 'post', config),
        editPx: config => createAPI('/examScheduleJnrd/editPx', 'post', config),
        noticeHxjs: config => createAPI('/examScheduleJnrd/noticeHxjs', 'post', config),
        roleInfo: config => createAPI('/examScheduleJnrd/roleInfo', 'post', config),
        queryKsapById: config => createAPI('/examScheduleJnrd/queryKsapById', 'post', config),
        queryHxjsByKsapid: config => createAPI('/examScheduleJnrd/queryHxjsByKsapid', 'post', config),
        querySfts: config => createAPI('/examScheduleJnrd/querySfts', 'post', config),
        editSfjs: config => createAPI('/examScheduleJnrd/editSfjs', 'post', config),
        esignSave: config => createAPI('/examScheduleJnrd/esignSave', 'post', config),
        kscdNoticeHxjs: config => createAPI('/examScheduleJnrd/kscdNoticeHxjs', 'post', config),
        queryXsmdList: config => createAPI('/examScheduleJnrd/queryXsmdList', 'post', config),
        queryJslb: config => createAPI('/examScheduleJnrd/queryJslb', 'post', config),
        batchExport: config => createAPI('/examScheduleJnrd/batchExport', 'post', config),
        queryLtpcmdList: config => createAPI('/examScheduleJnrd/queryLtpcmdList', 'post', config),
        proctoringCountsList: config => createAPI('/examScheduleJnrd/proctoringCountsList', 'post', config),
        batchProctoringCountsExport: config => createAPI('/examScheduleJnrd/batchProctoringCountsExport', 'post', config),
        planManagementFileList: config => createAPI('/examScheduleJnrd/planManagementFileList', 'post', config),
        planManagementFileUpload: config => createAPI('/examScheduleJnrd/planManagementFileUpload', 'post', config),
        deletePlanMessageFile: config => createAPI('/examScheduleJnrd/deletePlanMessageFile', 'post', config),
    },
    examSearch: {
        list: config => createAPI('/examSearchJnrd/list', 'post', config),
        initOption: config => createAPI('/examSearchJnrd/initOption', 'post', config),
        queryClassTree: config => createAPI('/examSearchJnrd/queryClassTree', 'post', config),
        queryTeaTree: config => createAPI('/examSearchJnrd/queryTeaTree', 'post', config),
        baseParam: config => createAPI('/examSearchJnrd/baseParam', 'post', config),
        queryExamInfo: config => createAPI('/examSearchJnrd/queryExamInfo', 'post', config),

        exportPaperBag: config => createAPI('/examSearchJnrd/exportPaperBag', 'post', config),
        exportExamArrange: config => createAPI('/examSearchJnrd/exportExamArrange', 'post', config),
        exportInvigilator: config => createAPI('/examSearchJnrd/exportInvigilator', 'post', config),
        exportStuSign: config => createAPI('/examSearchJnrd/exportStuSign', 'post', config),
        exportBkStuSign: config => createAPI('/examSearchJnrd/exportBkStuSign', 'post', config),
    },
    outsideSiteManagement: {
        queryList: config => createAPI('/xwcdglJnrd/queryList', 'post', config),
        save: config => createAPI('/xwcdglJnrd/save', 'post', config),
        deleteById: config => createAPI('/xwcdglJnrd/deleteById', 'post', config),
        initCombo: config => createAPI('/xwcdglJnrd/initCombo', 'post', config),
    },
    evaluatorsManagement: {
        queryList: config => createAPI('/kpryglJnrd/queryList', 'post', config),
        save: config => createAPI('/kpryglJnrd/save', 'post', config),
        deleteById: config => createAPI('/kpryglJnrd/deleteById', 'post', config),
        initCombo: config => createAPI('/kpryglJnrd/initCombo', 'post', config),
        batchExport: config => createAPI('/kpryglJnrd/batchExport', 'post', config),
        drkpry: config => createAPI('/kpryglJnrd/drkpry', 'post', config),
    },
    appraisalPersonnelManagement: {
        queryList: config => createAPI('/kpryglJnrd/queryList', 'post', config),
        saveKpryInfo: config => createAPI('/kpryglJnrd/saveKpryInfo', 'post', config),
        deleteById: config => createAPI('/kpryglJnrd/deleteById', 'post', config),
        initCombo: config => createAPI('/kpryglJnrd/initCombo', 'post', config),
        batchExportinfo: config => createAPI('/kpryglJnrd/batchExportinfo', 'post', config),
        drkpryinfo: config => createAPI('/kpryglJnrd/drkpryinfo', 'post', config),
        examManageManageFileList: config => createAPI('/kpryglJnrd/examManageManageFileList', 'post', config),
        examManageManageFileUpload: config => createAPI('/kpryglJnrd/examManageManageFileUpload', 'post', config),
        deleteExamManageManageFile: config => createAPI('/kpryglJnrd/deleteExamManageManageFile', 'post', config),
    },
    evaluatorsLogin: {
        login: config => createAPI('/evaluatorsLoginJnrd/login', 'post', config),
        queryList: config => createAPI('/evaluatorsLoginJnrd/queryList', 'post', config),
        queryKsapById: config => createAPI('/evaluatorsLoginJnrd/queryKsapById', 'post', config),
        initCombo: config => createAPI('/evaluatorsLoginJnrd/initCombo', 'post', config),
        esignSave: config => createAPI('/evaluatorsLoginJnrd/esignSave', 'post', config),
        editSfjs: config => createAPI('/evaluatorsLoginJnrd/editSfjs', 'post', config),
        queryhxjsinfo: config => createAPI('/evaluatorsLoginJnrd/queryhxjsinfo', 'post', config),
    },
};


export default examManageJnrd;



// WEBPACK FOOTER //
// ./src/api/modules/examManageJnrd.js